import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import type { GenerateSuperAgentTokenResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Generate (or rotate) the workspace's Super Agent bot token. Any existing token is
 * revoked and a fresh `mp_…` is minted; the full secret is returned once. Requires
 * AI to be enabled for the workspace and the Manage AI settings permission.
 */
const generateSuperAgentToken = async (
  workspaceSlug: string,
): Promise<GenerateSuperAgentTokenResponse> => {
  try {
    const response = await AuthAxios.post<GenerateSuperAgentTokenResponse>(
      `${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/super-agent/token`,
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('Enable AI for this workspace to manage the Super Agent token.')
    }
    throw error
  }
}

export default generateSuperAgentToken
